// extracted by mini-css-extract-plugin
export default {"container":"sales_container__ONw6n","TabListStyleOverride":"sales_TabListStyleOverride__fq2eI"};